import {
  Component,
  OnDestroy,
  OnInit,
  QueryList,
  TemplateRef,
  ViewChild,
  ViewChildren,
  ViewContainerRef,
  signal,
} from '@angular/core';
import { ImportExportComponent } from '../settings/dialogs/import-export/import-export.component';
import { filter, Subscription } from 'rxjs';
import { logExport, exportJsonToExcel } from '../globals';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import moment from 'moment';
import { dataStore } from '../app.component';
import { DataStoreExport } from '../interfaces';
import { Role } from '../enums';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { MatTabGroup, MatTab, MatTabLabel, MatTabContent } from '@angular/material/tabs';
import { AuditComponent } from './tabs/audit/audit.component';
import { DebitOrdersComponent } from './tabs/debit-orders/debit-orders.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { PaymentPlansComponent } from './tabs/payment-plans/payment-plans.component';

@Component({
  selector: 'app-financial',
  templateUrl: './financial.component.html',
  styleUrl: './financial.component.scss',
  imports: [
    MatIcon,
    MatButton,
    MatTabGroup,
    MatTab,
    MatTabLabel,
    MatTabContent,
    AuditComponent,
    DebitOrdersComponent,
    PaymentPlansComponent,
    MatProgressSpinner,
  ],
})
export class FinancialComponent implements OnInit, OnDestroy {
  loadingPage = signal(true);
  @ViewChildren('tab') tabComponents: QueryList<any>;
  @ViewChild('debitOrdersOutlet', { read: ViewContainerRef })
  debitOrdersOutletRef: ViewContainerRef;
  @ViewChild('debitOrders', { read: TemplateRef }) debitOrdersRef: TemplateRef<any>;
  selectedIndex = signal(0);
  processing = signal(false);
  dataStore: DataStoreExport = dataStore;
  Role = Role;

  tabs = [
    {
      key: 'audits',
      name: 'Audits',
      url: 'audits',
      icon: 'fact_check',
    },
    {
      key: 'debitOrders',
      name: 'Incasso historie',
      url: 'debit-orders',
      icon: 'account_balance',
    },
    {
      key: 'paymentPlans',
      name: 'Betaalplannen',
      url: 'payment-plans',
      icon: 'euro_symbol',
    },
  ];

  private routeSubscription: Subscription = new Subscription();

  get activeTab(): any {
    return this.tabComponents?.toArray()[this.selectedIndex()];
  }

  constructor(
    public dialog: MatDialog,
    public router: Router,
    public snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    // Subscribe to router navigation events to handle view changes
    this.routeSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateSelectedIndex();
      });
    // Set initial view
    this.updateSelectedIndex();
    this.loadingPage.set(false);
  }

  ngOnDestroy(): void {
    this.routeSubscription.unsubscribe();
  }

  updateUrl() {
    const tab = this.tabs[this.selectedIndex()];
    this.router.navigate([`/financial/${tab.url}`]);
  }

  updateSelectedIndex() {
    const url = this.router.url;

    switch (true) {
      case url.includes('/financial/audits'):
        this.selectedIndex.set(0);
        break;
      case url.includes('/financial/debit-orders'):
        this.selectedIndex.set(1);
        break;
      case url.includes('/financial/payment-plans'):
        this.selectedIndex.set(2);
        break;
      default:
        this.selectedIndex.set(0);
        break;
    }
  }

  async exportFilteredAudits() {
    const dialogRef = this.dialog.open(ImportExportComponent, {
      width: '300px',
      data: { type: 'audits', onlyExport: true },
    });
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result && this.activeTab.getFilteredAudits) {
        const result = this.activeTab.getFilteredAudits();
        this.processing.set(true);
        const rowsArray = [];
        let errorCounter = 0;
        result.filteredAudits.forEach(async (audit) => {
          try {
            const rowObj: any = {};
            rowObj['Naam'] = audit.userData.name;
            rowObj['Datum'] = moment(audit.date.toDate()).format(
              result.showTime ? 'DD-MM-YYYY HH:mm' : 'DD-MM-YYYY',
            );
            if (audit['creditsSpent']) {
              rowObj['Credits'] = -audit.creditsSpent;
            } else if (audit['creditsAdded']) {
              rowObj['Credits'] = audit.creditsAdded;
            }
            rowObj['Beschrijving'] = audit['description'];
            rowObj['Voertuig'] = audit['vehicleName'];
            if (result?.showCharacteristics) {
              rowObj['Kenmerken'] = audit.characteristics
                ? audit.characteristics.toString().replaceAll(',', ', ')
                : '-';
            }
            rowObj['Opmerkingen'] = audit['remarks'];
            rowObj['Behandelaar'] = audit['actionBy'];
            if (audit['rideId']) {
              rowObj['Rit_ID'] = audit['rideId'];
            } else {
              rowObj['Rit_ID'] = '-';
            }
            rowsArray.push(rowObj);
          } catch (err) {
            errorCounter++;
          }
        });
        console.log(rowsArray);

        let message = '';
        if (rowsArray.length > 0) {
          const date = moment(new Date()).format('DD-MM-YYYY');
          await exportJsonToExcel(rowsArray, `Audit_Export_${date}.xlsx`, 'Audits');
          message = 'Bestand geëxporteerd.';
          await logExport('audit');
        } else {
          message = 'Geen exporteerbare data binnen geselecteerde filters.';
        }
        if (errorCounter) {
          message = message + ` ${errorCounter} rijen konden niet worden verwerkt.`;
        }
        this.snackBar.open(message, '', {
          duration: 5000,
        });
        this.processing.set(false);
      }
    });
  }
}
